export default "__VITE_ASSET__B132EThL__"